import { render, staticRenderFns } from "./OverviewBilling.vue?vue&type=template&id=405e4bf1&scoped=true"
import script from "./OverviewBilling.vue?vue&type=script&lang=js"
export * from "./OverviewBilling.vue?vue&type=script&lang=js"
import style0 from "./OverviewBilling.vue?vue&type=style&index=0&id=405e4bf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e4bf1",
  null
  
)

export default component.exports